<template>
	<div>
		<div class="air__utils__heading d-flex align-items-center">
			<h5>Profile</h5>
		</div>
		<a-form :form="form" @submit="handleSubmit">
			<a-form-item v-bind="formItemLayout" label="Avatar">
				<UserAvatar class="mt-3" />
			</a-form-item>
			<a-form-item v-bind="formItemLayout" label="E-mail">
				<a-input
					v-decorator="[
						'email',
						{
							initialValue: this.getCurrentUser.email,
							rules: [
								{
									type: 'email',
									message: 'The input is not valid E-mail!',
								},
								{
									required: true,
									message: 'Please input your E-mail!',
								},
							],
						},
					]"
				/>
			</a-form-item>
			<a-form-item v-bind="formItemLayout" label="Name">
				<a-input
					v-decorator="[
						'firstname',
						{
							initialValue: this.getCurrentUser.firstname,
							rules: [
								{
									required: true,
									message: 'Please input your E-mail!',
								},
							],
						},
					]"
				/>
			</a-form-item>
			<a-form-item v-bind="formItemLayout" label="Last Name">
				<a-input
					v-decorator="[
						'lastname',
						{
							initialValue: this.getCurrentUser.lastname,
							rules: [
								{
									required: true,
									message: 'Please input your E-mail!',
								},
							],
						},
					]"
				/>
			</a-form-item>

			<a-form-item v-bind="tailFormItemLayout">
				<a-button type="default" html-type="submit">
					Update
				</a-button>
			</a-form-item>
		</a-form>
	</div>
</template>

<script>
import { USER as USER_ACTIONS } from '@/store/actions'
import { mapActions, mapGetters } from 'vuex'
import UserAvatar from '@/components/widgets/User/Avatar'

export default {
	components: {
		UserAvatar,
	},
	data() {
		return {
			form: this.$form.createForm(this),

			formItemLayout: {
				labelCol: {
					xs: { span: 4 },
					sm: { span: 4 },
				},
				wrapperCol: {
					xs: { span: 12 },
					sm: { span: 12 },
				},
			},
			tailFormItemLayout: {
				wrapperCol: {
					xs: {
						span: 2,
						offset: 4,
					},
					sm: {
						span: 2,
						offset: 4,
					},
				},
			},
		}
	},
	created() {},
	methods: {
		handleSubmit(e) {
			e.preventDefault()
			this.form.validateFieldsAndScroll((err, values) => {
				if (!err) {
					this.updateUser({
						id: this.getCurrentUser.id,
						firstname: values.firstname,
						lastname: values.lastname,
						email: values.email,
					}).then(e => {
						this.$notification.success('User updated')
					})
				}
			})
		},
		...mapActions({ updateUser: USER_ACTIONS.UPDATE }),
	},
	computed: {
		...mapGetters(['getCurrentUser']),
	},
}
</script>

<style></style>
